module.exports = __webpack_public_path__ + "assets/img/walletBg1.03b9a6c2.png";